import React from 'react';
import { cn } from '@/utils';

interface SegmentedControlOption {
  id: string;
  label: string;
  icon?: React.ReactNode;
}

interface SegmentedControlProps {
  options: SegmentedControlOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const SegmentedControl: React.FC<SegmentedControlProps> = ({
  options,
  value,
  onChange,
  className,
}) => {
  return (
    <div className={cn('flex p-1 bg-gray-100 dark:bg-white/5 rounded-xl relative', className)}>
      {options.map((option) => (
        <label key={option.id} className="flex-1 cursor-pointer relative z-10">
          <input
            type="radio"
            name="segmented-control"
            value={option.id}
            checked={value === option.id}
            onChange={() => onChange(option.id)}
            className="peer sr-only"
          />
          <div
            className={cn(
              'h-10 w-full flex items-center justify-center gap-1.5 rounded-lg text-sm font-medium transition-all duration-200',
              'text-gray-500 dark:text-gray-400',
              'peer-checked:bg-white dark:peer-checked:bg-surface-dark',
              'peer-checked:text-emerald-700 dark:peer-checked:text-primary',
              'peer-checked:shadow-sm'
            )}
          >
            {option.icon && <span className="text-current">{option.icon}</span>}
            <span>{option.label}</span>
          </div>
        </label>
      ))}
    </div>
  );
};

export default SegmentedControl;
